module.exports = __webpack_public_path__ + "img/if_1.a1579a3a.png";